import {Record} from 'immutable'
import {readAsDataUrl, createObjectUrl} from "../utilites/helpers/file";

export interface IVideoModel {
  url: string;
  isSaved: boolean;
}

const VideoModelStateRecord = Record({
  isSaved: false,
  url: '',
  file: null
});

class VideoModelState extends VideoModelStateRecord {

}

export class VideoModel implements IVideoModel {
  protected _state: VideoModelState;

  constructor() {
    this._state = new VideoModelState();
  }

  setVideoFile(value: File): Promise<VideoModel> {
    return Promise.resolve(
      this._cloneFromState(
        this._state
          .set('file', value)
          .set('url', createObjectUrl(value))
      )
    );
  }

  get file() {
    return this._state.get('file');
  }

  get url(): string {
    return this._state.get('url');
  }

  get m3u8_url(): string {
    return this._state.get('m3u8_url');
  }

  set url(url: string) {
    throw 'unsupported method';
  }

  get isSaved(): boolean {
    return this._state.get('isSaved');
  }

  static fromSource(videoUrl: string) {

  }

  protected _cloneFromState(state: VideoModelState): VideoModel {
    let res = new VideoModel();
    res._state = state;
    return res;
  }
}

export class StreamS3Video implements IVideoModel {
  protected _videoUrl: string;

  constructor(url: string) {
    this._videoUrl = url;
  }

  get url(): string {
    return this._videoUrl;
  }

  set url(url: string) {
    throw 'unsupported method';
  }

  get isSaved(): boolean {
    return true;
  }

  set isSaved(val: boolean) {
    throw 'unsupported method';
  }
}



// WEBPACK FOOTER //
// ./src/api/video.ts